export const animateAppearance = (containerEl: HTMLElement | SVGElement | null, type: 'appear' | 'disappear') => {
  if (!containerEl) {
    return;
  }

  const direction = type === 'appear' ? 'normal' : 'reverse';

  return containerEl.animate([{ opacity: 0 }, { opacity: 1 }], {
    duration: 500,
    easing: 'ease-in-out',
    fill: 'both',
    direction,
  });
};

export const animateSlide = (containerEl: HTMLElement | SVGElement | null, type: 'up' | 'down') => {
  if (!containerEl) {
    return;
  }

  const direction = type === 'up' ? 'normal' : 'reverse';

  return containerEl.animate([{ transform: 'translateY(100%)' }, { transform: 'translateY(0)' }], {
    duration: 500,
    easing: 'ease-in-out',
    fill: 'both',
    direction,
  });
};
